import { useNavigate } from 'react-router-dom'
import type { BackProps } from './index.type'
import Ripple from '@/components/Ripple'

export default function Back({ onClick, className = '' }: BackProps) {
    const navigate = useNavigate()

    const handleClick = () => {
        if (onClick) {
            onClick()
        } else {
            navigate(-1)
        }
    }

    return (
        <Ripple className={`rounded-full`}>
            <div
                onClick={handleClick}
                className={`flex items-center justify-center w-10 h-10 bg-[#F4F6F9] rounded-full ${className}`}
            >
                <img className="w-4" src="/icon/back.svg" />
            </div>
        </Ripple>
    )
}